import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    redirect: '/swap',
  },
  {
    path: '/swap',
    name: 'swap',
    component: () => import('@/views/Swap.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/foundation',
    name: 'foundation',
    component: () => import('@/views/Foundation.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '/Staking',
    name: "Staking",
    component: () => import('@/views/Staking/index.vue'),
    meta: {
      layout: 'content',
    },
  },
  {
    path: '*',
    redirect: 'error-404',
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})

export default router
